module.exports = __webpack_public_path__ + "assets/images/bg_1b2c5eca247cae9ac08002411267c454.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/bg.png
// module id = 32
// module chunks = 0